import { FORM_MODES } from 'config/formModes';
import { BASE_FORM_ROUTE_PATH, FORM_MODE_TO_PATH_MAP } from 'config/routes';
import { replacePathParams } from 'modules/campaigns/services/utils/replacePathParams';
import { ACCOUNT_PARAM_TEMPLATE } from './account';
import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';
import { LANDING_PAGE_ID_PARAM_TEMPLATE } from './landing-page';

const KEY_TO_PATH_MAP_MAP = {
    mode: FORM_MODE_TO_PATH_MAP,
    entity: ENTITY_TO_PATH_MAP,
};

export const LANDING_PAGES_REPORTS_ROUTE_PATH = `${BASE_FORM_ROUTE_PATH}${ACCOUNT_PARAM_TEMPLATE}${LANDING_PAGE_ID_PARAM_TEMPLATE}`;

export const LANDING_PAGE_CREATOR_ROUTE_PATH = replacePathParams(
    LANDING_PAGES_REPORTS_ROUTE_PATH,
    {
        entity: [ENTITY.LANDING_PAGE],
        mode: [FORM_MODES.CREATE],
    },
    [],
    KEY_TO_PATH_MAP_MAP
);

export const LANDING_PAGE_EDITOR_ROUTE_PATH = replacePathParams(
    LANDING_PAGES_REPORTS_ROUTE_PATH,
    {
        entity: [ENTITY.LANDING_PAGE],
        mode: [FORM_MODES.EDIT, FORM_MODES.PREVIEW],
    },
    ['module', 'accountId', 'landingPageId'],
    KEY_TO_PATH_MAP_MAP
);
